export default __webpack_public_path__ + "static/media/2ed8626faeef5155288504eaa8b8d5c9.00311935.png";